export class BackupZeroEtlAwsAccessConfiguration {
    'allowedPrincipals';
    'requirePrincipalTags';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "allowedPrincipals",
            "baseName": "allowedPrincipals",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "requirePrincipalTags",
            "baseName": "requirePrincipalTags",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BackupZeroEtlAwsAccessConfiguration.attributeTypeMap;
    }
    constructor() {
    }
}
